import preFetchAsync from '../framework/preFetchAsync'
import wechatShareMixin from 'lib/mixins/wechatShare'

// function getMeta(vm) {
//   const { meta } = vm.$options
//   if (meta) {
//     return typeof meta === 'function'
//       ? meta.call(vm, {store: vm.$store})
//       : meta
//   }
// }

const isServer = process.env.VUE_ENV === 'server'

let judgeOnce = true
const clientPageMixin = {
  mixins: [wechatShareMixin],
  data() {
    return {
      fetchError: false
    }
  },
  mounted() {
    this._setTitle()
    this.$nextTick(() => {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    })

    if (this.isWebviewMp) {
      this.setMiniProgram()
    }
  },
  activated() {
    this._setTitle()
  },
  created() {
    // 改到entryClient 路由生命周期处理
    this.fetchPromise = Promise.resolve()
    // this.runPreFetch()
  },
  methods: {
    runPreFetch() {
      this.fetchPromise = Promise.resolve()
      const { dataStore } = this.$options

      // 组件是否有prefetch方法
      // const hasPreFetch = typeof preFetch === 'function'
      // if (dataStore) {
      //   this.$store.registerModule(dataStore.name, dataStore.store, {
      //     preserveState: judgeOnce
      //   })
      // }
      // const isSamePath = window.__INITIAL_STATE__.route.fullPath === this.$route.fullPath
      if (!judgeOnce) {
        //|| !window.__INITIAL_STATE__.serverRendered
        this.fetchPromise = preFetchAsync(this.$router, this.$store)
      } else if (dataStore) {
        let storeList = []

        if (Object.prototype.toString.call(dataStore) === '[object Array]') {
          storeList = [...dataStore]
        } else {
          storeList = [dataStore]
        }

        storeList.forEach(ds => {
          const { name, store: _store } = ds
          this.$store.registerModule(name, _store, {
            preserveState: true
          })
        })
      }

      // this.fetchPromise.then(() => {
      //   this._setTitle()
      //   return Promise.resolve()
      // })

      // 只判断一次
      judgeOnce = false
      this.fetchPromise.catch(err => {
        if (err.code === 301) {
          // this.$router.replace(err.data.url)
          this.routerReplace(err.data.url)
        } else if (err.code === 302) {
          // this.$router.replace(err.data.url)
          this.routerReplace(err.data.url)
        }
        this.fetchError = true
      })
      return this.fetchPromise
    },
    _setTitle() {
      // let meta = getMeta(this) || {}
      // document.title = meta.title || '壹心理'
      // this.$store.commit('setMeta', meta)
    }
  },
  computed: {
    metaTitle() {
      return this.$store.state.meta.title
    },
    pageData() {
      const { dataStore } = this.$options
      if (dataStore) {
        return this.$store.state[dataStore.name]
      } else {
        return {}
      }
    }
  }
  // watch: {
  // vue-wehcat-title处理
  // metaTitle(val) {
  //   if (val) document.title = val
  // }
  // },
  // destroyed() {
  //   const { dataStore } = this.$options
  //   if (dataStore) {
  //     this.$store.unregisterModule(dataStore.name)
  //   }
  // }
}

const serverPageMixin = {
  data() {
    return {
      fetchError: false
    }
  },
  created() {
    this.fetchPromise = Promise.resolve()
    this.fetchPromise.catch(() => {
      this.fetchError = true
    })
  }
}

export default isServer ? serverPageMixin : clientPageMixin
